<template>
  <div class="receiveset">
    <template v-if="$route.name == 'IPReceiveSettings'">
      <ots-main-title></ots-main-title>
      <ots-table-group-new
        :selectList="selectList"
        :requestForm="requestForm"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :batchOperBtn="batchOperBtn"
        @search="search"
      >
      </ots-table-group-new>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import {
  getInfoFn,
  deletedelInfo,
  setsaveInfo,
} from "@/http/modules/baseSet/majorCourse";
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getPlanSite } from "@/http/modules/examSet/section";
export default {
  name: "",
  data() {
    return {
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "手机号",
          prop: "teacherPhone",
        },
        {
          title: "操作",
          type: "buttons",
          width: "165",
          btnList: [
            {
              title: "删除",
              click: this.delTeacher,
            },
          ],
        },
      ],
      batchOperBtn: [
        {
          title: "添加手机号",
          click: this.setPhoen,
        },
      ],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "考点",
          type: "select",
          requestKey: "placeId",
          label: "name",
          value: "id",
        },
      ],
      pagination: {
        total: 0,
        page: 1,
      },
      tableData: [],
      PlanListParams: {
        order: "",
        page: 1,
        size: 10,
      },
      requestForm: {
        planId: "",
        placeId: "",
      },
      teacherPhone: "",
    };
  },
  watch: {
    "requestForm.planId"(val) {
      this.initSiteData(val);
      this.search()
    },
    'requestForm.placeId'(){
      this.search()
    }
  },
  created() {
    this.initData();
    this.initSiteData()
  },
  methods: {
    async initData() {
      let { data } = await getSelectPlanFn({ needAudit: 6 });
      this.$set(this.selectList[0], "data", data);
      if (data.length) {
        this.requestForm.planId = data[0].id;
      }
    },
    initSiteData(planId) {
      getPlanSite({ planId: planId }).then((data) => {
        this.$set(this.selectList[1], "data", data.data);
        if (data.data) {
          this.requestForm.placeId = data.data[0].id;
        } else {
          this.requestForm.placeId = "";
        }
      });
    
    },
    async search() {
      let params = { ...this.requestForm };
      getInfoFn(params).then((res) => {
        this.tableData = res.data;
      });
    },
    setPhoen() {
      this.$router.push({
        name: "setSettingsIphone",
      });
    },
    delTeacher(row) {
      deletedelInfo({ id: row.id }).then((res) => {
        if (res.code == 1) {
          this.$message.success("删除成功");
          this.search();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>